import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { projectProductReferenceService } from '@/services/data';

export function useProjectProductReferences(projectId: string | undefined) {
  const queryClient = useQueryClient();
  const queryKey = ['projectProductReferences', projectId] as const;
  const query = useQuery({
    queryKey,
    enabled: Boolean(projectId),
    queryFn: () => projectProductReferenceService.list(projectId!),
  });
  const replace = useMutation({
    mutationFn: (productIds: string[]) =>
      projectProductReferenceService.replace(projectId!, productIds),
    onSuccess: () => queryClient.invalidateQueries({ queryKey }),
  });
  return { ...query, replace };
}
